export default __webpack_public_path__ + "static/media/SpheroEdu.5b36f6e4.png";